import React, { useState } from "react";
import PropTypes from "prop-types";

const FilteredVideoCarousel = ({ serviceCategory, videos }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [expandedId, setExpandedId] = useState(null);

  const truncateDescription = (description) => {
    if (description) {
      return description.length > 50
        ? description.slice(0, 50) + "..."
        : description;
    }
  };

  const toggleReadMore = (id) => {
    setExpandedId((prevId) => (prevId === id ? null : id));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % videos.length);
  };

  const goToPrev = () => {
    setCurrentIndex((prev) => (prev - 1 + videos.length) % videos.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  if (!videos || videos.length === 0) {
    return (
      <div className="mt-12 text-center p-12 bg-alt rounded-[30px]">
        <p className="text-lg opacity-80">
          No videos available for {serviceCategory}
        </p>
      </div>
    );
  }

  const currentVideo = videos[currentIndex];
  const isExpanded = expandedId === currentVideo._key;

  return (
    <div className="mt-12">
      <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center  lg:hidden">
        {serviceCategory}
      </h3>

      <div className="bg-alt rounded-[30px] overflow-hidden ">
        {/* Video Container - Smaller */}
        <div className=" mx-auto">
          <div className="relative">
            {/* Video with 16:9 aspect ratio */}
            <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
              <iframe
                key={currentVideo._key}
                src={currentVideo.video?.replace("/view", "/preview")}
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                allow="autoplay; encrypted-media"
                title={currentVideo.description}
              />
            </div>

            {/* Previous Button */}
            {videos.length > 1 && (
              <button
                onClick={goToPrev}
                className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-3 transition-all duration-300 z-10"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>
            )}

            {/* Next Button */}
            {videos.length > 1 && (
              <button
                onClick={goToNext}
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-3 transition-all duration-300 z-10"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            )}
          </div>

          {/* Description */}
          <div className="mt-6 p-4 text-white text-center">
            {currentVideo.description && (
              <h3 className="text-base md:text-lg font-semibold">
                {isExpanded
                  ? currentVideo.description
                  : truncateDescription(currentVideo.description)}
                {currentVideo.description.length > 50 && (
                  <span
                    className="ml-2 text-primary cursor-pointer hover:underline text-sm"
                    onClick={() => toggleReadMore(currentVideo._key)}
                  >
                    {isExpanded ? "اقرأ أقل" : "اقرأ المزيد"}
                  </span>
                )}
              </h3>
            )}
          </div>

          {/* Indicators (Dots) */}
          {videos.length > 1 && (
            <div className="flex flex-row-reverse justify-center gap-2 mt-4">
              {videos.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentIndex
                      ? "bg-primary w-8"
                      : "bg-white/30 hover:bg-white/50"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          )}

          {/* Video Counter */}
          <div className="text-center mt-4">
            <p className="text-base opacity-80">
              Video {currentIndex + 1} of {videos.length}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

FilteredVideoCarousel.propTypes = {
  serviceCategory: PropTypes.string.isRequired,
  videos: PropTypes.array.isRequired,
};

export default FilteredVideoCarousel;
